import { render, staticRenderFns } from "./StudentsWalletReportFilter.vue?vue&type=template&id=7fbcbf6a&"
import script from "./StudentsWalletReportFilter.vue?vue&type=script&lang=js&"
export * from "./StudentsWalletReportFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports